import MobileBeginAtStart from "./begin-at-the-start";
import MobileFindYourPlan from "./find-your-plan";
import MobileHeroBanner from "./hero-baner";
import MobileIndustriesGradient from "./industries-gradient";
import MobileDistributionWarehouse from "./offerings/distribution-warehouse";
import MobileHealthcare from "./offerings/healthcare";
import MobileHoaResidential from "./offerings/hoa-residential";
import MobileHospitalityVenue from "./offerings/hospitality-venue";
import MobileManufacturingProcessing from "./offerings/manufacturing-processing";
import MobileOfficeMixedUse from "./offerings/office-mixed-use";
import MobileRetailGrocery from "./offerings/retail-grocery";
import MobileThumbOnPulse from "./thumb-on-the-pulse";

const MobileIndustriesComponents = () => {
  return (
    <section>
      <div className="space-y-10">
        <MobileHeroBanner />
        <MobileThumbOnPulse />
        <MobileIndustriesGradient />
      </div>
      <MobileRetailGrocery />
      <MobileManufacturingProcessing />
      <MobileHospitalityVenue />
      <MobileDistributionWarehouse />
      <MobileHealthcare />
      <MobileOfficeMixedUse />
      <MobileHoaResidential />
      <MobileBeginAtStart />
      <MobileFindYourPlan />
    </section>
  );
};

export default MobileIndustriesComponents